import React, {useState, useEffect, useRef} from 'react'
import {sha256} from "js-sha256";

const ServerSelect = (props:any) => {

    const onNewSubmit = () => {
        let url = "https://d.myameego.com/core/login.php?submit&f&username=" + props.username + "&password=" + sha256(props.password) + "&client_id=" + props.cid

        window.location.href=url;
    }

    const onOldSubmit = () => {
        let url = "https://c.myameego.com/core/login.php?submit&f&username=" + props.username + "&password=" + sha256(props.password) + "&client_id=" + props.cid

        window.location.href=url;
    }

    return (
        <>
            <div className={"mt-8"}>
                <h1>Experience the Future of Ameego!</h1>
                <p>✨We’ve crafted a fresh look for Ameego, emphasizing effortless usability. Dive in to
                    explore or continue with our classic version. ✨</p>
                <div className="container">
                    <div>
                        <button className="button" onClick={()=> onNewSubmit()}>Try New Look</button>
                    </div>
                    <div>
                        <button className="button"  onClick={()=> onOldSubmit()}>Stay Classic</button>
                    </div>
                </div>
                <div className="info">
                    To switch back to the classic look after trying the new interface, please log out and log back in.
                    🔄
                </div>
                <div className="warning">
                    The classic look will be phased out in the future. We encourage you to familiarize yourself with our
                    new interface. ⏳
                </div>
                <div className={"link"} onClick={() => props.beta(false)}>
                    <p>Go Back</p>
                </div>
            </div>
        </>
    )
}

export default ServerSelect;